<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fluid">
    <!-- 头部顶部 -->
    <div class="header-top container-fluid hidden-xs">
      <div class="container" style="padding-top: 2rem">
        <div class="pull-left">
          <span class="glyphicon" style="padding-top: 5px; margin-right: 3rem"><img class="logo-img"
              src="@/assets/img/logo.png" alt="奥软信息技术(上海)有限公司" /></span>
        </div>
        <div class="pull-left">
          <span class="logo-text">奥软信息技术(上海)有限公司</span>
        </div>
        <div class="pull-right">
          <a href="https://www.orizon.co.jp/" target="_blank" class="button-left">
            <span class="glyphicon glyphicon-globe"></span>オリゾン本社へ
          </a>
          <a href="/ContactUs" class="button-right">
            <span class="glyphicon glyphicon-earphone"></span>联系我们
          </a>
        </div>
      </div>
    </div>
    <!-- 电脑导航 -->
    <div class="header-nav container" style="margin-bottom: 1px">
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li v-for="(item, index) in navList" :key="index" :class="{'active' : index == navIndex || index == chooseTitlebagecolor}"
          @click="navClick(index, item)">
          <div>
            {{ item.name }}
            <i class="underline"></i>
          </div>
          <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <div>{{ i.name }}</div>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fluid visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo_black.png" alt="logo" />
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item)" data-toggle="collapse" data-target="#menu">
            <div>
              {{ item.name }}
              <i class="underline"></i>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        // {
        //   name: "公司信息",
        //   path: "/companyintroduction",
        //   children: [],
        // },
        {
          name: "新闻中心",
          path: "/newsinformation",
          children: [],
        },
        {
          name: "技术服务",
          path: "/service",
          children: [
            // {
            //   name: "系统软件开发",
            //   path: "/software/smartTown"
            // },
            // {
            //   name: "EDA软件开发",
            //   path: "/software/bigData"
            // },
            // {
            //   name: "制造业软件开发",
            //   path: "/software/bigData"
            // },
            // {
            //   name: "海外开发",
            //   path: "/software/bigData"
            // }
          ]
        },
        {
          name: "公司信息",
          path: "/companyintroduction",
          children: [],
        },
        {
          name: "联系我们",
          path: "/ContactUs",
          children: [],
        },
      ],
      newsList: [ '/newsinformation/newsDetails' ],
      service: [ '/service/development', '/service/eda', '/service/manufacture', '/service/offshore' ],
    };
  },
  computed: {
    chooseTitlebagecolor() {
      let activeIndex = ''
      this.navList.forEach((item, index) => {
        if (item.path) {
          if (item.path == this.$route.path) {
            this.navIndex = index
            activeIndex = index
          }
        }
      })
      this.newsList.forEach(item => {
        if (item == this.$route.path) {
          this.navIndex = 1
          activeIndex = 1
        }
      })
      this.service.forEach(item => {
        if (item == this.$route.path) {
          this.navIndex = 2
          activeIndex = 2
        }
      })
      return activeIndex
    }
  },
  methods: {
    navClick(index, item) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = item.name;
      this.$router.push(item.path)
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
}

#header .header-top {
  color: black;
  font-size: 12px;
  line-height: 50px;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
  border: 1px solid blue;
}

#header .header-nav .header-nav-wrapper {
  line-height: 35px;
  margin: 0;
  display: flex;
  justify-content: space-between;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper>li {
  width: 15%;
  position: relative;
  text-align: center;
  border-bottom: 2px solid white;
  cursor: pointer;
}

#header .header-nav .header-nav-wrapper>li:hover {
  border-bottom: 2px solid rgb(165, 193, 214);
}

#header .header-nav .header-nav-wrapper .active {
  border-bottom: 2px solid #1e73be;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper>li>a {
  color: #000;
  font-size: 15px;
  /* padding: 9px 0; */
  position: relative;
  letter-spacing: 1px;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper>li>a>i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  /* background-color: #1e73be; */
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper>li>a>span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover {
  color: #1e73be;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper>li.active>a {
  color: #1e73be;
  text-decoration: none;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper>li>dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper>li>dl>dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper>li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
  cursor: pointer;
  background: #ccc;
}

.pull-right>a {
  text-decoration: none;
}

.button-left:hover {
  border: 1px solid rgb(32, 101, 168);
  background-color: rgb(32, 101, 168);
  color: white;
  padding: 7px 2em 8px 1.1em;
}

.button-left {
  border: 1px solid rgb(32, 101, 168);
  margin-right: 10px;
  padding: 7px 2em 8px 1.1em;
}

.button-right:hover {
  color: rgb(32, 101, 168);
  border: 1px solid rgb(32, 101, 168);
  background-color: white;
  padding: 7px 3em 8px 2.1em;
}

.button-right {
  border: 1px solid rgb(32, 101, 168);
  background-color: rgb(32, 101, 168);
  color: white;
  letter-spacing: 3px;
  padding: 7px 3em 8px 2.1em;
}

.logo-text {
  color: rgb(118, 118, 118);
  letter-spacing: 1px;
  font-size: 17px;
  /* font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; */
  font-weight: 600;
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper>li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper>li>a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 10px;
  }
}</style>



// WEBPACK FOOTER //
// src/components/Header.vue